module.exports = __webpack_public_path__ + "img/cicon3.5d972d92.png";